import React, { useState, useEffect } from "react";
import {
  FiHome,
  FiShoppingCart,
  FiUser,
  FiHeart,
} from "react-icons/fi";
import { FaGripHorizontal } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import LoginModal from "./LoginModal";
import { useCart } from '../context/CartContext';

function MobileFoot() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const location = useLocation(); 
const [menuOpen, setMenuOpen] = useState(false);

const { cartCount } = useCart();
  const userData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
  const displayName = isLoggedIn && userData ? userData.name : "Account";

  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    setIsLoggedIn(!!customerId);
  }, []);

  // ❌ Hide footer for /product/:slug route
  if (/^\/product\/[^/]+$/.test(location.pathname)) {
    return null;
  }

  return (
    <>
      {/* 📱 Mobile Bottom Navigation */}
      <nav className="mobile-bottom-nav mobile-only">
        <Link
          to="/"
          className={`mobile-nav-item ${
            location.pathname === "/" ? "active" : ""
          }`}
        >
          <FiHome size={22} />
          <span>Home</span>
        </Link>

        <Link
          to="/all-categories"
          className={`mobile-nav-item ${
            location.pathname === "/all-categories" ? "active" : ""
          }`}
        >
          <FaGripHorizontal size={22} />
          <span>Categories</span>
        </Link>

        <Link
          to="/cart"
          className={`mobile-nav-item ${
            location.pathname === "/cart" ? "active" : ""
          }`}
        >
          <FiShoppingCart size={22} /> 
          <span>Cart  {cartCount > 0 && (
          <span className=" mobilecart">
            {cartCount}
          </span>
        )}  </span>
        </Link>

        {isLoggedIn ? (
          <Link
            to="/profile"
            className={`mobile-nav-item ${
              location.pathname === "/profile" ? "active" : ""
            }`}
          >
            <FiUser size={22} />
           <span>{displayName ? displayName.split(' ')[0] : 'Guest'}</span>
          </Link>
        ) : (
          <div
            className="mobile-nav-item"
            onClick={() => { setLoginModal(true); setMenuOpen(false); }}
            style={{ cursor: "pointer" }}
          >
            <FiUser size={22} />
            <span>Login</span>
          </div>
        )}
      </nav>

      <LoginModal show={loginModal} onClose={() => setLoginModal(false)} />

      <style>{`
        /* 🌈 Mobile Bottom Nav Styling */
        .mobile-bottom-nav {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          height: 65px;
          background: #ffffff;
          display: flex;
          justify-content: space-around;
          align-items: center;
          border-top: 1px solid #eee;
          box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
          z-index: 999;
          transition: all 0.3s ease;
        }

        .mobile-nav-item {
          flex: 1;
          text-align: center;
          text-decoration: none;
          color: #777;
          font-size: 13px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease-in-out;
          padding-top: 5px;
        }

        .mobile-nav-item svg {
          margin-bottom: 3px;
          transition: transform 0.25s ease, color 0.25s ease;
        }

        /* 🟢 Active Item */
        .mobile-nav-item.active {
          color: #f54c4d;
          font-weight: 600;
          text-decoration: none !important;
        }

        .mobile-nav-item.active svg {
          color: #f54c4d;
          transform: scale(1.15);
        }

        /* 🧢 Hover (Optional) */
        .mobile-nav-item:active {
          background: rgba(0, 123, 255, 0.1);
        }

        /* 📱 Responsive Only */
        @media (min-width: 992px) {
          .mobile-bottom-nav {
            display: none !important;
          }
        }
      `}</style>
    </>
  );
}

export default MobileFoot;
